import React, { Fragment, useCallback } from 'react';
import { string, func, array } from 'prop-types';
import { translate } from 'react-i18next';
import classNames from 'classnames/bind';

import facebookButtonTheme from '@snapask/common-components/styles/buttonTheme/facebook.scss';
// TODO: [Web-220323-1650] will add KAKAO type
// import kakaoTalkButtonTheme from '@snapask/common-components/styles/buttonTheme/kakaoTalk.scss';
import loginTypeButtonTheme from '@snapask/common-components/styles/buttonTheme/loginType.scss';
import nowTVTheme from '@snapask/common-components/styles/buttonTheme/nowTV.scss';

import {
  FACEBOOK_AUTH_TYPE,
  NOWTV_AUTH_TYPE,
  // TODO: [Web-220323-1650] will add KAKAO type
  // KAKAO_AUTH_TYPE,
} from '@dragonfruit/constants/authType';
import { PHONE, EMAIL } from '@dragonfruit/constants/signupAuthType';

import {
  Button,
  FacebookIcon,
  PhoneIcon,
  EmailIcon,
  NowTVIcon,
  // TODO: [Web-220323-1650] will add KAKAO type
  // KakaoIcon,
} from '@snapask/common-components';

import styles from './LoginTypeSwitcher.scss';

const cx = classNames.bind(styles);

function LoginTypeSwitcher({ t, providerList, value, onClickHandler }) {
  const typeList = [...providerList, EMAIL, PHONE];
  const typeButtonMapping = {
    [FACEBOOK_AUTH_TYPE]: {
      icon: (
        <FacebookIcon className={styles.whiteIcon} width={24} height={24} />
      ),
      buttonText: t('login.authType.facebook'),
      theme: facebookButtonTheme,
    },
    [EMAIL]: {
      icon: <EmailIcon width={24} height={20} />,
      buttonText: t('login.authType.email'),
      theme: loginTypeButtonTheme,
    },
    [PHONE]: {
      icon: <PhoneIcon width={24} height={24} />,
      buttonText: t('login.authType.phone'),
      theme: loginTypeButtonTheme,
    },
    [NOWTV_AUTH_TYPE]: {
      icon: <NowTVIcon className={styles.whiteIcon} width="auto" height={24} />,
      buttonText: t('login.authType.nowtv'),
      theme: nowTVTheme,
    },
    // TODO: [Web-220323-1650] will add KAKAO type
    // [KAKAO_AUTH_TYPE]: {
    //   icon: <KakaoIcon width={24} height={24} />,
    //   // TODO: will update i18n key
    //   buttonText: t('login.authType.kakao'),
    //   theme: kakaoTalkButtonTheme,
    // },
  };
  const getButtonTextComponent = useCallback(
    (icon, buttonText) => (
      <Fragment>
        <span className={styles.icon}>{icon}</span>
        <span className={styles.buttonText}>{buttonText}</span>
      </Fragment>
    ),
    []
  );

  const handleClick = type => event => {
    event.preventDefault();
    onClickHandler(type);
  };

  return (
    <div className={styles.root}>
      {typeList.map(type => {
        if (!typeButtonMapping[type]) return null;
        const { icon, buttonText, theme } = typeButtonMapping[type];

        return (
          <div
            className={cx(styles.button, {
              hide: value === type,
            })}
            key={type}
          >
            <Button
              text={getButtonTextComponent(icon, buttonText)}
              onClick={handleClick(type)}
              primary
              theme={theme}
              fullWidth
            />
          </div>
        );
      })}
    </div>
  );
}

LoginTypeSwitcher.propTypes = {
  providerList: array.isRequired,
  t: func.isRequired,
  value: string.isRequired,
  onClickHandler: func.isRequired,
};

export default translate(['login'])(LoginTypeSwitcher);



// WEBPACK FOOTER //
// ./app/components/LoginTypeSwitcher/LoginTypeSwitcher.jsx